import type { SVGProps } from "react";

export function IconBlueHeadset(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2 33.5C2 27.701 6.70101 23 12.5 23H19V44H12.5C6.70101 44 2 39.299 2 33.5Z"
        fill="#41D8F6"
        stroke="#41D8F6"
        strokeWidth="1.5"
      />
      <path
        d="M45 23H51.5C57.299 23 62 27.701 62 33.5C62 39.299 57.299 44 51.5 44H45V23Z"
        fill="#41D8F6"
        stroke="#41D8F6"
        strokeWidth="1.5"
      />
      <circle cx="35" cy="57" r="5" stroke="#23232C" strokeWidth="1.5" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.75 25C11.75 13.8162 20.8162 4.75 32 4.75C43.1838 4.75 52.25 13.8162 52.25 25V45C52.25 51.2132 47.2132 56.25 41 56.25H39.25V57.75H41C48.0416 57.75 53.75 52.0416 53.75 45V25C53.75 12.9878 44.0122 3.25 32 3.25C19.9878 3.25 10.25 12.9878 10.25 25V44.525C10.7392 44.6243 11.24 44.6918 11.75 44.7254V25Z"
        fill="#23232C"
      />
    </svg>
  );
}
